import React from "react";
import { Link } from 'react-router-dom';
import Header from './header';
import Main from './main';
import Footer from './footer';

export default function Home() {
    return (
        <div>
            <Header />
            <Main />
            <Footer />
        </div>
    );
};